export const SET_STEPPER = 'SET_STEPPER';
export const SET_STEP = 'SET_STEP';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_COMPLETE_STEP = 'SET_COMPLETE_STEP';
export const RESET_STEP = 'RESET_STEP';
